import { openUploadModal } from './upload.js';
import { openSelectModal } from './select.js';

const homeTabOrder = ['home', 'download', 'convert', 'preload', 'manage'];
let homeTabAnimating = false;
document.querySelectorAll('#homeTabs a').forEach(a => {
  a.addEventListener('click', (e) => {
    e.preventDefault();
    if (homeTabAnimating) return;
    const target = a.dataset.homeTab;
    const currentEl = document.querySelector('.home-tab-panel.active');
    const targetEl = document.querySelector(`.home-tab-panel[data-home-panel="${target}"]`);
    if (!currentEl || !targetEl || currentEl === targetEl) return;

    homeTabAnimating = true;

    // Determine direction based on tab order
    const currentIdx = homeTabOrder.indexOf(currentEl.dataset.homePanel);
    const targetIdx = homeTabOrder.indexOf(target);
    const goingRight = targetIdx > currentIdx;

    // Update tab UI
    document.querySelectorAll('#homeTabs a').forEach(x => x.classList.remove('active'));
    a.classList.add('active');

    // Outgoing: current panel slides out
    currentEl.classList.remove('active');
    currentEl.classList.add(goingRight ? 'exit-left' : 'exit-right');

    // Incoming: position target on opposite side instantly (no transition), then activate
    targetEl.classList.add('no-slide-transition');
    targetEl.classList.add(goingRight ? 'enter-from-right' : 'enter-from-left');
    // Force reflow so position is committed
    // eslint-disable-next-line no-unused-expressions
    targetEl.offsetHeight;
    requestAnimationFrame(() => {
      targetEl.classList.remove('no-slide-transition');
      // Force reflow so transition re-enables before active class applies
      // eslint-disable-next-line no-unused-expressions
      targetEl.offsetHeight;
      targetEl.classList.remove('enter-from-right', 'enter-from-left');
      targetEl.classList.add('active');
    });

    // Cleanup after transition
    setTimeout(() => {
      // Disable transition before resetting position so the panel doesn't
      // visibly slide back from exit-left/right to the default position
      currentEl.classList.add('no-slide-transition');
      currentEl.classList.remove('exit-left', 'exit-right');
      // Force reflow
      // eslint-disable-next-line no-unused-expressions
      currentEl.offsetHeight;
      // Re-enable on next frame
      requestAnimationFrame(() => {
        currentEl.classList.remove('no-slide-transition');
      });
      homeTabAnimating = false;
    }, 420);
  });
});

const uploadBar = document.getElementById('uploadBar');
const fileInput = document.getElementById('fileInput');
const uploadCta = document.getElementById('uploadCta');

uploadBar.addEventListener('click', (e) => {
  if (e.target.closest('#uploadCta')) return;
  fileInput.click();
});
uploadCta.addEventListener('click', (e) => {
  e.stopPropagation();
  fileInput.click();
});
fileInput.addEventListener('change', (e) => {
  const file = e.target.files[0];
  if (file) openUploadModal(file);
  e.target.value = '';
});

['dragenter', 'dragover'].forEach(ev => {
  uploadBar.addEventListener(ev, (e) => { e.preventDefault(); uploadBar.classList.add('drag'); });
});
['dragleave', 'drop'].forEach(ev => {
  uploadBar.addEventListener(ev, (e) => {
    e.preventDefault();
    if (ev === 'dragleave' && uploadBar.contains(e.relatedTarget)) return;
    uploadBar.classList.remove('drag');
  });
});
uploadBar.addEventListener('drop', (e) => {
  e.preventDefault();
  const file = e.dataTransfer.files[0];
  if (file) openUploadModal(file);
});

// Select bar
document.getElementById('selectBar').addEventListener('click', openSelectModal);
document.getElementById('selectCta').addEventListener('click', (e) => {
  e.stopPropagation();
  openSelectModal();
});

// Preview header — "소재 변경": switch to a different title/creative while previewing
document.getElementById('previewSwitch').addEventListener('click', openSelectModal);

// Preview header — "다운로드": exit preview and jump straight to the Download tab
document.getElementById('previewToDownload')?.addEventListener('click', () => {
  // Leave the preview overlay so the home tabs (and their panels) are visible again
  document.getElementById('previewClose').click();
  // Then activate the Download tab (drives its slide animation + lazy render)
  const dl = document.querySelector('#homeTabs a[data-home-tab="download"]');
  if (dl && !dl.classList.contains('active')) dl.click();
});
